<template>
    <div class="appModule_app">

        <!-- <el-button
        type="primary"
        
        >
        指令方式
    </el-button> -->

        <!-- 轮播 -->
        <ShufflingApp></ShufflingApp>
        <!-- 列表 -->
        <!-- <HomePageAppOne></HomePageAppOne> -->
        <HomePageAppTwo></HomePageAppTwo>
        <HomePageApp></HomePageApp>
        <HomePageAppThree></HomePageAppThree>
    </div>
</template>
<script>
import Bus from '@/Bus'
import ShufflingApp from '@/components/appModule/shufflingApp/index'
import HomePageAppOne from '@/components/appModule/homePageAppOne/index'
import HomePageApp from '@/components/appModule/homePageApp/index'
import HomePageAppTwo from '@/components/appModule/homePageAppTwo/index'
import HomePageAppThree from '@/components/appModule/homePageAppThree/index'

export default {
    data(){
        return {
            
        }
    },
    components:{
        ShufflingApp,
        HomePageAppOne,
        HomePageApp,
        HomePageAppTwo,
        HomePageAppThree
    },
    created() {
        
       
    },
    methods:{

    }
}
</script>
<style lang="">
    .appModule_app{
        min-height:10rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/appModule/index.vue